// extracted by mini-css-extract-plugin
export default {"heading-5":"NSnFQ hRgdS","heading5":"NSnFQ hRgdS","background-color":"#F2F2F2","backgroundColor":"#F2F2F2","heading":"FCJaM NSnFQ hRgdS","productSizes":"p9njt","size":"VBGAD"};